import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const DossierValide = ({ listData }) => {
  const style = { fontFamily: "sans-serif" };
  return (
    <>
      {listData.allowed ? (
        <Col>
          <CardTitle style={{ color: "#555b21" }} className="mb-2">
            {listData.title}
          </CardTitle>
          <Card className="mini-stats-wid">
            <CardBody>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead className="nowrap-header">
                    <tr>
                      {listData.header.map((item, index) => (
                        <th key={index} className="text-nowrap">
                          {item}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {listData.data.length > 0 ? (
                      listData.data.map((item) => (
                        <tr key={item.id}>
                          <>
                            <td style={style}>{item.id}</td>
                            <td style={style}>
                              {item.montant.toLocaleString("fr-FR", {
                                style: "currency",
                                currency: "EUR",
                              })}
                            </td>
                            <td style={style}>{item.retrocession} </td>
                            <td style={style}>{item.valide_le} </td>
                            <td style={style}>{item.date_protocole}</td>
                          </>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={listData.header.length}>
                          Aucune donnée disponible
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default DossierValide;
